



import { Component, Vue, Prop } from 'vue-property-decorator';
// @ts-ignore
import SwaggerUI from 'swagger-ui';
import 'swagger-ui/dist/swagger-ui.css'

@Component({ name: 'SwaggerUI' })
export default class extends Vue {

    @Prop({required: true})
    url: string;

    mounted() {
        SwaggerUI({
            url: this.url,
            dom_id: '#swagger',
            // Hide 'Try it out'
            supportedSubmitMethods: [],
            presets: [
                SwaggerUI.presets.apis,
            ],
            validatorUrl: null,
            syntaxHighlight: {
                theme: 'nord'
            }
        })
    }

}
